import { useDispatch } from 'react-redux';
import { alertOpen } from '@/entities/Alert';
import { ActionContent } from '@/entities/Alert/model/slice/alertSlice';
import { ReactNode } from 'react';

export const useAlert = () => {
  const dispatch = useDispatch();
  return (content: ReactNode | ActionContent, isError?: boolean) => {
    dispatch(alertOpen({ content, isError }));
  };
};
